import { Link } from "react-router-dom";
import { useSettings } from "../../context/SettingsContext";
import { imgUrl } from "../../api";
import iconFacebook  from "../../assets/social/facebook.png";
import iconInstagram from "../../assets/social/instagram.png";
import iconTiktok    from "../../assets/social/tiktok.png";
import iconYoutube   from "../../assets/social/youtube.png";
import iconTwitter   from "../../assets/social/twitter.png";
import "./Footer.css";

export default function Footer() {
  const { settings } = useSettings();

  const {
    site_name, site_tagline, logo_url,
    contact_phone, contact_email, contact_address, contact_address_2,
    contact_hours_weekdays,
    social_facebook, social_instagram, social_tiktok, social_youtube, social_twitter,
  } = settings;

  const redesActivas = [
    { url: social_facebook,  icon: iconFacebook,  label: "Facebook" },
    { url: social_instagram, icon: iconInstagram, label: "Instagram" },
    { url: social_tiktok,    icon: iconTiktok,    label: "TikTok" },
    { url: social_youtube,   icon: iconYoutube,   label: "YouTube" },
    { url: social_twitter,   icon: iconTwitter,   label: "X" },
  ].filter((r) => r.url);

  return (
      <footer className="footer">
        <div className="container footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              {logo_url
                  ? <img src={imgUrl(logo_url)} alt={site_name} style={{ maxHeight: 48, maxWidth: 160, objectFit: "contain" }} />
                  : <>🏠 <strong>{site_name}</strong></>
              }
            </div>
            <p>{site_tagline}</p>
            {redesActivas.length > 0 && (
                <div className="footer-social">
                  {redesActivas.map((r) => (
                      <a key={r.label} href={r.url} target="_blank" rel="noreferrer"
                         className="footer-social-link" title={r.label}>
                        <img src={r.icon} alt={r.label} />
                      </a>
                  ))}
                </div>
            )}
          </div>

          <div className="footer-col">
            <h4>Navegación</h4>
            <ul>
              <li><Link to="/">Inicio</Link></li>
              <li><Link to="/propiedades?operation=VENTA">Propiedades en venta</Link></li>
              <li><Link to="/propiedades?operation=RENTA">Propiedades en renta</Link></li>
              <li><Link to="/contacto">Contáctanos</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contacto</h4>
            <ul>
              {(contact_address || contact_address_2) && (
                  <li>📍 {contact_address}{contact_address_2 ? `, ${contact_address_2}` : ""}</li>
              )}
              {contact_phone && (
                  <li>📞 <a href={`tel:${contact_phone.replace(/\D/g, "")}`}>{contact_phone}</a></li>
              )}
              {contact_email && (
                  <li>✉️ <a href={`mailto:${contact_email}`}>{contact_email}</a></li>
              )}
              {contact_hours_weekdays && (
                  <li>🕐 {contact_hours_weekdays}</li>
              )}
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} {site_name} · Todos los derechos reservados</span>
        </div>
      </footer>
  );
}
